import { on, createReducer } from '@ngrx/store';
import { programsSearch, programsSearchSuccess } from './program.actions';
import { StoreState } from '../../enums/store-state';
import { Program } from 'src/generated/graphql';

export const programFeatureKey = 'programFeatureKey';

export interface ProgramState {
  programState: StoreState;
  programs: Program[];
}

export const initialState: ProgramState = {
  programState: StoreState.idle,
  programs: [],
};

export const programReducer = createReducer(
  initialState,

  on(programsSearch, (state) => ({
    ...state,
    programState: StoreState.inProgress,
    programs: [],
  })),
  on(programsSearchSuccess, (state, data) => ({
    ...state,
    programState: StoreState.success,
    programs: data.programs,
  }))
);
